<div class="hero">
  <div *ngFor="let image of backgroundImages; let i = index" class="hero-bg"
    [class.active]="i === currentBackgroundIndex" [style.background-image]="'url(' + image + ')'"></div>
  <div class="hero-inner">
    <h1 class="hero-title slideInUp">{{ "Knowledge gate" | translator }}</h1>

    <form class="hero-search slideInUp" (ngSubmit)="submitSearch()">
      <i class="pi pi-search hero-search-icon"></i>
      <input type="text" name="search" class="hero-search-input sstarabic" [(ngModel)]="searchText"
        placeholder="{{ 'ابحث عن خدمة، سؤال شائع' | translator }}" [disabled]="searchDisabled" />
      <button type="submit" class="hero-search-btn" [disabled]="searchDisabled">
        <i class="pi pi-search"></i>
        <span>{{ "Discus" | translator }}</span>
      </button>
    </form>

    <div class="hero-row slideInUp">
      <div class="hero-chips">
        <button type="button" class="hero-chip" [class.active]="searchType === 'all'"
          (click)="searchType = 'all'">{{ "الكل" | translator }}</button>
        <button type="button" *ngFor="let item of quickTypes" class="hero-chip"
          [class.active]="searchType === item.type?.arabic" (click)="searchType = item.type?.arabic">
          {{ item.type?.arabic }}
        </button>
        <ng-container *ngIf="countsPending">
          <span class="skeleton hero-chip-skeleton"></span>
          <span class="skeleton hero-chip-skeleton"></span>
        </ng-container>
      </div>

      <button type="button" class="hero-advanced" [routerLink]="searchDisabled ? null : '/advance-search'"
        [disabled]="searchDisabled">
        <span>{{ "advanced search" | translator }}</span>
        <i class="pi pi-angle-left"></i>
      </button>
    </div>
  </div>
</div>

<div *ngIf="countsPending" class="stats" aria-busy="true">
  <div *ngFor="let _ of [1, 2, 3]" class="stat-card stat-card-skeleton">
    <span class="skeleton stat-icon"></span>
    <span class="stat-text">
      <span class="skeleton skeleton-line" style="width: 7rem"></span>
      <span class="skeleton skeleton-line" style="width: 5rem"></span>
    </span>
  </div>
</div>

<div *ngIf="serviceCounts?.length > 0 && showServiceCount" class="stats">
  <button type="button" *ngFor="let item of statTypes" class="stat-card stat-rise"
    [disabled]="searchDisabled" (click)="openLicenseModal(item)">
    <span class="stat-icon"><i class="pi {{ statIcon(item) }}"></i></span>
    <span class="stat-text">
      <span class="stat-title">{{ item?.type?.arabic }}</span>
      <span class="stat-count"><strong>{{ item?.count }}</strong> {{ statUnit(item) }}</span>
    </span>
    <i class="pi pi-angle-left stat-arrow"></i>
  </button>
</div>

<p-dialog [blockScroll]="true" [draggable]="false" [(visible)]="visibleModal"
  header="{{ currentFieldType?.type?.arabic }}" [style]="{ width: '95vw', maxWidth: '800px' }">
  <ng-template pTemplate="body">
    <div role="button" (click)="navigateToResult(ou)" class="home-modal-bar" *ngFor="let ou of filteredOus">
      <div class="d-flex gap-1 align-items-center" style="width: fit-content">
        <div class="v4-icon-bg">
          <img src="{{ staticURL + ou.image }}" style="object-fit: contain; width: 100%; height: 100%"
            *ngIf="checkisImg(ou?.image); else elseBlock" alt="" />
        </div>
        <ng-template #elseBlock>
          <i class="pi pi-{{ ou?.image }}" style="font-size: 1rem"></i>
        </ng-template>
        <span style="font-size: 16px; color: var(--color-text-grey)">{{ ou.name }}</span>
      </div>
      <span style="font-size: 14px; color: var(--color-text-grey)">{{ getCount(ou) }}</span>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
  </ng-template>
</p-dialog>
